// @flow

import type { PaginationExtendedType } from "@types";
import type { State } from "@store/reducers";
import type { SpecialContact } from "@modules/service/reducer/special-contacts/types";

import { getPagination } from "@selectors";

export const getSpecialContacts = (state: State) => state.service.specialContacts.list.content;

export const getSpecialContactsListOptions = (state: State) =>
  state.service.specialContacts.listOptions;

export const getSpecialContactsPagination = (state: State): PaginationExtendedType =>
  getPagination(state.service.specialContacts.list);

export const getCurrentSpecialContact = (state: State): ?SpecialContact =>
  state.service.specialContacts.current;

export const getSpecialContactsEmployeesList = (state: State) =>
  ((state.service.specialContacts || {}).employeesList || {}).content;

export const getSpecialContactsEmployeesPagination = (state: State): PaginationExtendedType => {
  return getPagination(getSpecialContactsEmployeesList(state));
};

export const getShowAddSpecialContactModal = (state: State) =>
  state.service.specialContacts.modals.showAddModal;

export const getShowEditSpecialContactModal = (state: State) =>
  state.service.specialContacts.modals.showEditModal;

export const getShowDeleteSpecialContactModal = (state: State) =>
  state.service.specialContacts.modals.showDeleteModal;
